if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this._bindBackdropClose();
      }

      _bindBackdropClose() {
        this._onBackdropClick = (event) => {
          if (!event.target.closest('.product-media-modal__toggle')) {
            this.hide();
          }
        };
        this.addEventListener('click', this._onBackdropClick);
      }

      showActiveMedia() {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
          element.style.setProperty('display', 'none', 'important');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.style.setProperty('display', 'flex', 'important');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
